import supabase from '../supabase/supabase';

const TABLE = 'recurring_expenses';

function resultOf(result) {
  if (result.error) throw result.error;
  return result.data;
}

function requireAffected(rows, message) {
  if (!rows?.length) throw new Error(message);
  return rows;
}

function toExpense(row) {
  return {
    id: row.id,
    name: row.name,
    category: row.category,
    amountCents: Number(row.amount_cents),
    frequency: row.frequency,
    anchorDate: row.anchor_date
  };
}

function toFields(values) {
  return {
    name: values.name,
    category: values.category,
    amount_cents: values.amountCents,
    frequency: values.frequency,
    anchor_date: values.anchorDate
  };
}

export async function loadExpenses(workspaceId) {
  const rows = resultOf(await supabase.from(TABLE).select('*')
    .eq('workspace_id', workspaceId).order('created_at').order('id'));
  return rows.map(toExpense);
}

export async function createExpense(workspaceId, ownerId, values) {
  resultOf(await supabase.from(TABLE).insert({
    workspace_id: workspaceId,
    owner_id: ownerId,
    ...toFields(values)
  }));
}

export async function updateExpense(workspaceId, id, values) {
  requireAffected(resultOf(await supabase.from(TABLE).update(toFields(values))
    .eq('id', id).eq('workspace_id', workspaceId).select('id')),
  'This expense no longer exists.');
}

export async function deleteExpense(workspaceId, id) {
  requireAffected(resultOf(await supabase.from(TABLE).delete()
    .eq('id', id).eq('workspace_id', workspaceId).select('id')),
  'This expense no longer exists.');
}